module.exports = __webpack_public_path__ + "static/media/ic_switch_full_screen_white.60b33292.svg";